const swiper = new Swiper(".multi-videos-swiper", {
  // Optional parameters
  direction: "horizontal",
  loop: false,
  autoHeight: true,
  allowTouchMove: false,
  navigation: {
    nextEl: ".multiVideo-carousel-next",
    prevEl: ".multiVideo-carousel-prev",
  },
  pagination: {
    el: ".multiVideo-carousel-pagination",
    clickable: true,
  },
});
